import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals, CurrencyKey, Ref } from '../globals';
import { BehaviorSubject, Subscription } from 'rxjs';

export interface PrCmpa {
  active: number;
  createdAt: any;
  name: string;
  description: string;
  code: string;
  classnId: any;
  updatedAt: any;
  characs: Features[];
  prices: PriceList[];
  reorderQuantity: number;
  unitRef: Ref;
  lastPriceUsed: number;
}

interface Features {
  name: string;
  value: string;
  unitId: any;
  nameUnit?: string;
}
interface PriceList {
  price: number;
  supplierId: any;
  supplierName?: string;
  usesIva: boolean;
  amountIva: number;
  currency: CurrencyKey;
}

export interface PrCmpaId extends PrCmpa {
  id: string;
}

@Injectable()
export class ProductCmpaService implements OnDestroy {

  /* prCmpaCollection: AngularFirestoreCollection<PrCmpa>;
  prCmpas: any;

  prCmpaDocument: AngularFirestoreDocument<PrCmpaId>;
  prCmpa: Observable<PrCmpaId>; */
  prCmpaSub: Subscription;

  collection: string;
  classnRef: string;
  unitCollection: string;
  supplierCollection: string;

  constructor(
    private afs: AngularFirestore,
    public afh: FirestoreService,
    public router: Router,
  ) {
    this.collection = Globals.PRCMPA_COLLECTION;
    this.classnRef = Globals.PRTYPE_COLLECTION;
    this.unitCollection = Globals.UNIT_COLLECTION;
    this.supplierCollection = Globals.CUSTOMER_SUPPLIER_COLLECTION;
  }
  ngOnDestroy(){
    this.prCmpaSub && this.prCmpaSub.unsubscribe();
  }

  /**
   * Get all prCmpas with references
   * @return {Observable} Arrays of prCmpas
   */
  private prCmpas$: BehaviorSubject<any[]>;
  getPrCmpas({onEmpty=undefined, getCashed=false}={}): Observable<any[]> {
    if(this.prCmpas$ && getCashed) return this.prCmpas$.map(prCmpas => {
      let newPrCmpas = [];
      for(let prCmpa of prCmpas){
        let newPrCmpa = {};
        for(let field in prCmpa) newPrCmpa[field] = prCmpa[field];//] typeof prCmpa[field] == 'object' ? {...prCmpa[field]} : prCmpa[field];
        newPrCmpas.push(newPrCmpa);
      }
      return newPrCmpas
    });
    let prCmpas$ = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) ).map(documents => {
      console.log(`Fetched ${documents.length} prCmpas.`);

      if(!documents.length && onEmpty) onEmpty();
      let documents$ = documents.map(document => {
        const classRef = this.afh.docWithIds$(document.classnId.path);
        let subObs = Observable.combineLatest(
          classRef,
          (classData ) => {
            return {
              classns: classData
            };
        })
        .map(data => {
          let doc = {
            data: data.classns,
            ...document
          };
          return doc;
        });
        return subObs;
      });
      return documents$;
    })
    .mergeMap(prCmpasDocuments => Observable.combineLatest(prCmpasDocuments));
    if(!this.prCmpas$){
      this.prCmpas$ = new BehaviorSubject([]);
      this.prCmpaSub = prCmpas$.subscribe(prCmpas => {
        this.prCmpas$.next(prCmpas);
      });
    }
    return prCmpas$;
  }

  /**
  * Get prCmpa data
  * @param {string} sid - The id of the prCmpa
  * @return {Observable} The PrCmpa Object
  */
  getPrCmpa(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid).map(document => {
      const classRef = this.afh.docWithIds$(document.classnId.path);
      return Observable.combineLatest(
        classRef,
        (classData ) => {
          return {
            classns: classData
          };
      })
      .map(data => {
        return {
          data: data.classns,
          ...document
        };
      });
    })
    .mergeMap(prCmpasDocuments => Observable.combineLatest(prCmpasDocuments));
  }


  /**
  * Create new prCmpa
  * @param {PrCmpa} prCmpa - The data of the prCmpa
  */
  addPrCmpa(prCmpa: any) {
    prCmpa.classnId = this.afh.doc(`${this.classnRef}/${prCmpa.classnId}`).ref;
    prCmpa.characs.map(charac => {
      charac.unitId = this.afh.doc(`${this.unitCollection}/${charac.unitId}`).ref
    });
    prCmpa.prices.map(price => {
      price.supplierId = this.afh.doc(`${this.supplierCollection}/${price.supplierId}`).ref;
    });
    this.afh.add(`${this.collection}`, prCmpa);
  }

  /**
   * Update current prCmpa
   * @param {string} sid  - The id of the prCmpa
   * @param {PrCmpa} prCmpa - The data of the prCmpa
   */
  updatePrCmpa(sid: string, prCmpa: Partial<PrCmpa>) {
    if(prCmpa.classnId) prCmpa.classnId = this.afh.doc(`${this.classnRef}/${prCmpa.classnId}`).ref;
    if(prCmpa.characs) prCmpa.characs.map(charac => {
      charac.unitId = this.afh.doc(`${this.unitCollection}/${charac.unitId}`).ref;
    });
    if(prCmpa.prices) prCmpa.prices.map(price => {
      price.supplierId = this.afh.doc(`${this.supplierCollection}/${price.supplierId}`).ref;
    });
    this.afh.update(`${this.collection}/${sid}`, prCmpa);
    this.router.navigate(['/prCmpa']);

  }

  /**
   * Delete current prCmpa
   * @param {string} sid - The id of the prCmpa
   */
  deletePrCmpa(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  getUnitDoc(ref: string) {
    return this.afh.docWithIds$(ref);
  }
  getSupplierDoc(ref: string) {
    return this.afh.docWithIds$(ref);
  }
  

}

/* class PRCMPA{

  name;
  description;

  code;
  classnId;
  characs;
  prices;
  constructor({name, className, cName1, cValue1, cUnitName1, cName2, cValue2, cUnitName2}){
    let cLass = JSON.parse(localStorage.prCTypes)[className == 'Fletes (XT)' ? 'Fletes' : className] || console.log('error: ' + className);
    if(cUnitName1 == 'Frascos') cUnitName1 = 'Frasco';if(cUnitName1 == 'Litros') cUnitName1 = 'Litro';if(cUnitName2 == 'Frascos') cUnitName2 = 'Frasco';if(cUnitName2 == 'Litros') cUnitName2 = 'Litro';
    let unitId1 = JSON.parse(localStorage.units)[cUnitName1] || console.log('error: ' + cUnitName1);
    let unitId2 = JSON.parse(localStorage.units)[cUnitName2];
    this.name = name.replace(new RegExp(';;QUOTES;;','g'), '"');
    this.description = this.name;
    this.code = `${cLass.short}${Math.ceil(Math.random()*1000)}${Math.ceil(Math.random()*100)}${Math.ceil(Math.random()*1000)}`;
    this.classnId = cLass.id;
    this.characs = [
      { name: cName1, value: this.num(cValue1), unitId: unitId1, nameUnit: cUnitName1 },
    ]
    if(cUnitName2) this.characs.push( { name: cName2, value: this.num(cValue2), unitId: unitId2, nameUnit: cUnitName2 } );
    //Object.keys(this.characs).map(key => {if(this.characs[key] === undefined) console.log('error_c_u' + key); else console.log('good_c')});
    //sire
    this.characs = [
      { name: 'Ancho', value: wide, unitId: 'b15CMrBc7Ive6qtzBtqL', nameUnit: 'Centímetro' },
      { name: 'Largo', value: long, unitId: 'b15CMrBc7Ive6qtzBtqL', nameUnit: 'Centímetro' },
      { name: 'Cal', value: cal, unitId: 'vqgSH63y7lfRH2yxQJ1c', nameUnit: 'Puntos' }
    ];
    //agro-web
    this.characs = [
      { name: 'Ancho', value: wide, unitId: 'Npea1iqE56xzimEMQTnm', nameUnit: 'Centímetro' },
      { name: 'Largo', value: long, unitId: 'Npea1iqE56xzimEMQTnm', nameUnit: 'Centímetro' },
      { name: 'Cal', value: cal, unitId: 'EeYoviR9MB619hB0vhAz', nameUnit: 'Puntos' }
    ];
    this.prices = [];
  }

  num(number: string = '0'): number{
    return +number.replace(',', '.');
  }
}
let str = localStorage.prCmpas//.replace(new RegExp('"','g'), ';;QUOTES;;');
export var PRCMPAS = JSON.parse(str).map(prCmpa => new PRCMPA(prCmpa)); */
//